import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { RegistroPersonasEmpresasLibModule } from '@rpe/registro-personas-empresas-lib';

import { CoreModule } from './core/core.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app/app.component';

import { VistaUsuarioModule } from './features/vista-usuario/vista-usuario.module';

import { ActividadesModule } from './features/actividades/actividades.module';
import { EmpresasModule } from './features/empresas/empresas.module';
import { NavegacionModule } from './features/navegacion/navegacion.module';
import { PersonaModule } from './features/persona/persona.module';
import { RolesModule } from './features/roles/roles.module';

import { SharedModule } from './shared/shared.module';
import { UbicacionesModule } from './features/ubicaciones/ubicaciones.module';
import { VistaTramiteModule } from './features/vista-tramite/vista-tramite.module';

@NgModule({
  imports: [
    // angular
    BrowserAnimationsModule,
    BrowserModule,

    // core
    CoreModule,
    // FileSaverModule,

    // app
    AppRoutingModule,
    UbicacionesModule,
    RolesModule,
    EmpresasModule,
    NavegacionModule,
    PersonaModule,
    ActividadesModule,

    // vistas
    VistaUsuarioModule,
    VistaTramiteModule,

    // lib
    RegistroPersonasEmpresasLibModule,

    SharedModule
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
